import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { toast } from 'sonner';
import { ZodError } from 'zod';

import { logError } from '@/utils/log-error.util.ts';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong';

const isFetchBaseQueryError = (
    error: unknown,
): error is FetchBaseQueryError => {
    return typeof error === 'object' && error !== null && 'status' in error;
};

function isErrorWithMessage(
    error: unknown,
): error is { data: { message: string } } {
    return (
        typeof error === 'object' &&
        error !== null &&
        'data' in error &&
        typeof (error as any).data === 'object' &&
        (error as any).data !== null &&
        'message' in (error as any).data
    );
}

function isZodError(error: unknown): error is ZodError {
    return error instanceof ZodError;
}

export const toastError = (error: unknown, callerFunctionName: string = '') => {
    logError(callerFunctionName, error);

    if (!error) {
        toast.error(DEFAULT_ERROR_MESSAGE);
        return;
    }

    if (error instanceof Error) {
        toast.error(error.message);
        return;
    }

    if (typeof error === 'string') {
        toast.error(error);
        return;
    }

    if (isZodError(error)) {
        toast.error('Please fill out the payment form correctly');
        return;
    }

    if (isFetchBaseQueryError(error)) {
        if (isErrorWithMessage(error)) {
            toast.error(error.data.message);
            return;
        }
    }

    if (error) {
        toast.error(DEFAULT_ERROR_MESSAGE);
        return;
    }
};
